import type { DocumentDTO } from '@/services/documents';

const RENEWABLE_TYPES = new Set(['prescription', 'receita', 'recipe']);
const BLOCKED_STATUS = new Set(['CANCELLED', 'FAILED']);

/** Elegibilidade UI alinhada ao MVP T10 (MEMED prescription). */
export function isMemedPrescriptionRenewable(
  doc: Pick<DocumentDTO, 'documentType' | 'provider' | 'externalStatus' | 'providerDocumentId'>,
): boolean {
  const type = String(doc.documentType || '').toLowerCase();
  if (!RENEWABLE_TYPES.has(type)) return false;
  if (doc.provider !== 'MEMED') return false;
  if (!doc.providerDocumentId) return false;
  const status = String(doc.externalStatus || '').toUpperCase();
  if (status && BLOCKED_STATUS.has(status)) return false;
  return true;
}
